import React from 'react';
import Login from './login/Login';

function Dashboard() {
  return <Login/>;
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/Dashboard.js